import { createContext, useContext } from 'react';

import { frameStore } from 'apps/components/Frame/appManager';
import { UiPosition } from 'libs/rendering/gltf/config';
import { OldFrameSidebarWidth, CameraSettingPanelWidth } from 'styles/constants';
import { PanelType } from 'constants/global';
import { useRouterStore } from 'apps/hooks';
import { clientStore } from 'apps/client/app';

import { useViewerControl } from './gltf/hooks';

const ChatControlContext = createContext();

const panelTypeWidthMap = {
  [PanelType.Camera]: CameraSettingPanelWidth,
};

export const ChatControlProvider = ChatControlContext.Provider;
export const useChatControl = () => useContext(ChatControlContext);

export const calcRightOffset = () => {
  const viewerControl = useViewerControl();
  const chatControl = useChatControl();
  const routerStore = useRouterStore();

  const isAuxRightPanel =
    !viewerControl.isPreview &&
    (chatControl.chatVisible ||
      viewerControl.meshAnalysis?.visible ||
      viewerControl.isDiffPanelVisible ||
      viewerControl.shouldShowCameraPanel);

  const isLargeRightPannel = frameStore.canShowRightPanel;

  const offset = isAuxRightPanel
    ? panelTypeWidthMap[routerStore.route?.params?.panel] || UiPosition.bigPanel
    : isLargeRightPannel
    ? UiPosition.largePanel
    : 0;

  return offset;
};

export const useViewerWidth = () => {
  const rightOffset = calcRightOffset();

  const calcViewerWidth = offset => {
    let viewerWidth = '100%';
    if (!clientStore.isMobile) {
      let availableW = clientStore.windowWidth - offset;
      availableW -= OldFrameSidebarWidth;

      const minW = UiPosition.panel;
      if (availableW > minW) {
        viewerWidth = `${availableW.toFixed().toString()}px`;
      } else {
        viewerWidth = `${minW.toFixed().toString()}px`;
      }
    }
    return viewerWidth;
  };
  const viewerWidth = calcViewerWidth(rightOffset);

  return [viewerWidth, rightOffset];
};
